import React, { JSX, useContext } from 'react';

import {
  AchievementContent,
  AchievementContext
} from '../../contexts/achievement';
import AchievementDialog from './achievement-dialog';

type Props = {};

const NotificationDialog = (props: Props) => {
  const [achievement, setAchievement] = useContext(AchievementContext);

  const handleOnClose = (data: AchievementContent, index: number): void => {
    achievement.content[index].isHide = true;
    setAchievement({ ...achievement });

    if (data && data.onCloseCallback) data.onCloseCallback();
  };

  return (
    <>
      {achievement.content.map<JSX.Element>(
        (item: AchievementContent, index: number) =>
          !item.isHide ? (
            <AchievementDialog
              key={index}
              imageUrl={item.imageUrl!}
              priorityQueueNumber={item.priorityQueueNumber}
              onClose={() => handleOnClose(item, index)}
              onMaskClick={() => handleOnClose(item, index)!}>
              {item.message}
            </AchievementDialog>
          ) : (
            <React.Fragment key={index} />
          )
      )}
    </>
  );
};

export default NotificationDialog;
